export var isIE = function isIE() {
  var navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
  return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
};